import {
  RequestForNewPostTimeline,
  RequestPostTimeline,
  RequestTimelinePostComment,
} from '../models/request/requestTimeline';
import {
  ResponseCommentPost,
  ResponsePostTimeline,
} from '../models/response/responseTimeline';
import { baseApi } from './baseApi';

const TimelineAPI = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    //get list post
    getListPost: builder.mutation<ResponsePostTimeline[], RequestPostTimeline>({
      query: (params: RequestPostTimeline) => ({
        url: `/v0/posts`,
        method: 'GET',
        params,
      }),
    }),
    // new post timeline
    sendNewPost: builder.mutation<
      ResponsePostTimeline,
      RequestForNewPostTimeline
    >({
      query: (params: RequestForNewPostTimeline) => ({
        url: `/v0/posts`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['Timeline'],
    }),
    // get post
    getPost: builder.mutation<RequestPostTimeline, string>({
      query: (postId: string) => ({
        url: `/v0/posts/${postId}?countUp=true`,
        method: 'GET',
      }),
    }),
    // like
    sendLikePost: builder.mutation<ResponsePostTimeline, string>({
      query: (postId: string) => ({
        url: `/v0/posts/${postId}/nice`,
        method: 'POST',
      }),
    }),
    // dislike
    disLike: builder.mutation<ResponsePostTimeline, string>({
      query: (postId: string) => ({
        url: `/v0/posts/${postId}/nice`,
        method: 'DELETE',
      }),
    }),
    // get comment of post
    getCommentPost: builder.query<ResponseCommentPost[], string>({
      query: (postId: string) => ({
        url: `/v0/posts/${postId}/comments`,
        method: 'GET',
      }),
      providesTags: ['CommentPost'],
    }),
    // post comment
    postMessageComment: builder.mutation<
      ResponseCommentPost,
      RequestTimelinePostComment
    >({
      query: (params: RequestTimelinePostComment) => ({
        url: `/v0/posts/${params.id}/comments`,
        method: 'POST',
        body: params,
      }),
      invalidatesTags: ['CommentPost'],
    }),
  }),
});

export const {
  // useGetListPostQuery,
  useGetListPostMutation,
  useSendNewPostMutation,
  useGetPostMutation,
  useSendLikePostMutation,
  useDisLikeMutation,
  useGetCommentPostQuery,
  usePostMessageCommentMutation,
} = TimelineAPI;
